<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a
        class="float-right btn btn-warning ml-2"
        href="#"
        @click.prevent="importFinancials()"
      >
        <span class="icon icon-download"></span>
        <span class="text">Import Financials</span>
      </a>
      <a
        class="float-right btn btn-secondary"
        :href="route('admin.events.create')"
      >
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Events</h1>
      <AdminMenu class="pt-2" current="Training" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>

          <div class="row d-none d-xl-flex">
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center text-xl-left">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info mb-3 mr-sm-1 mb-sm-0 mb-xl-3"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-4 mb-3 mb-xl-0 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-4 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>

          <EventList
            :items="items"
            :columns="columns"
            :activeColumns="activeColumns"
            :hideNoResults="hideNoResults"
            :listEvents="listEvents"
            :cancellation-types="cancellationTypes"
            section="admin"
            @sort-by="setSort"
            @swap-column="setActiveColumn"
          />

          <div class="row">
            <div class="col-12 col-xl-3">
              <a
                v-if="items.length > 0"
                href="#"
                @click.prevent="showExportOptions()"
                class="btn btn-info"
              >
                <span class="icon icon-download"></span>
                <span class="text">Export List</span>
              </a>
            </div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize
                :value="parseInt(pagination.per_page)"
                @input="setPerPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import EventList from "components/partials/Events/List";

export default {
    mixins: [DisplaysAlerts, ListingMixin],
    components: {AdminMenu, EventList},
    props: {
        cancellationTypes: {type: Array, default: () => []}
    },
    methods: {
        importFinancials() {
            //
        },
    },
    mounted() {
        this.listEvents.$on("show-alert", this.showAlert);
    },
};
</script>
